<p-card styleClass="w-full" data-cy="order-wizard-order-summary">
  <app-patient-responsibility></app-patient-responsibility>
  <div *ngIf="requireOrderConfirmation$ | async" class="mt-5">
    <app-order-confirmation
      [showCheckbox]="!useForSubmission || (skipBillingStep$ | async)?.value || !!(paymentOptional$ | async)"
      [isTouched]="isConfirmationTouched"
      [disabled]="!!(updateCopayDeductibleOverridesState$ | async)?.isLoading"
    >
    </app-order-confirmation>
  </div>
  <ng-container *ngIf="selectedOutOfPocket$ | async as outOfPocket">
    <ng-component *ngIf="outOfPocket.primaryOutOfPocketMet || outOfPocket.secondaryOutOfPocketMet">
      The Out of Pocket amount has been met and the amount you pay is limited to the remaining balance.
    </ng-component>
  </ng-container>

  <div *ngIf="!useForSubmission" class="mt-5">
    <app-deductible-overrides-form
      [confirmDeductibleOverrides]="confirmDeductibleOverrides"
      (confirmDeductibleOverridesChange)="onConfirmDeductibleOverridesChange($event)"
    ></app-deductible-overrides-form>
  </div>
  <div *ngIf="useForSubmission">
    <!-- PLPWP-2187 Msg appears when there is no payment -->
    <ng-container *ngIf="selectedPaymentMethod$ | async as payMeth">
      <ng-container *ngIf="skipBillingStep$ | async as billStep">
        <div *ngIf="payMeth === null && billStep" class="mt-5">
          <app-message severity="error" data-cy="error-create-payment-method-api-message">
            Please add a payment method to authorize your order.
          </app-message>
        </div>
      </ng-container>
    </ng-container>

    <button
      pButton
      type="button"
      class="w-full mb-2"
      [ngClass]="(requireOrderConfirmation$ | async) ? 'mt-5' : 'mt-2'"
      [label]="
        isSubmittingReorder
          ? 'Submitting Order'
          : (paymentOptional$ | async)
          ? 'Authorize & Pay Now'
          : (skipBillingStep$ | async)
          ? 'Authorize'
          : 'Authorize & Pay'
      "
      [disabled]="isSubmittingReorder"
      data-cy="order-wizard-submit-button"
      (click)="onSubmit(true)"
      appClickEvent
      eventName="order_wizard_authorize_order"
    ></button>
    <button
      *ngIf="paymentOptional$ | async"
      pButton
      type="text"
      class="w-full mt-3 mb-5 p-button-text"
      label="Authorize & Pay Later"
      data-cy="order-wizard-pay-later-button"
      (click)="onSubmit(false)"
      appClickEvent
      eventName="order_wizard_authorize_order_pay_later"
    ></button>
    <p class="mt-3 mb-0 px-2 p4 w-full text-black-400">
      My confirmation indicates that I will need supplies by the time the shipment arrives. I authorize payment to CCS
      Medical and its affiliates for the service and supplies. I have received a copy of the Patient Supplies and
      Supplier Standards and Notice of Privacy Practices. Additionally, I have successfully completed training and am
      able to use the ordered items.
    </p>
  </div>
</p-card>

<div *ngIf="useForSubmission">
  <app-order-submission-loading-overlay [visible]="isSubmittingReorder"></app-order-submission-loading-overlay>

  <app-notification-overlay
    [(visible)]="displayPaymentError"
    title="Payment Failed"
    message="An error occured while submitting your payment. Please review your information and try submitting again."
    type="error"
  ></app-notification-overlay>

  <app-notification-overlay
    [(visible)]="displayOrderSubmissionError"
    title="Order Submission Failed"
    message="An error occured while submitting your order. Please review your information and try submitting again."
    [additionalDetails]="'Error Details: ' + (submitReorder$ | async)?.error?.uiMessage"
    type="error"
  ></app-notification-overlay>
</div>
